<template>
  <div class="section">
    <div class="container">
      <h1>Purchasing Access to Non-Public Index Materials</h1>
      <video src="https://ctc-document.s3.amazonaws.com/purchasingAccess.mp4" controls>
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>
